import type { IconProps } from './types';
import './icons.css';

export default function HideAll({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-hide-all ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M10.685 10.302a1.163 1.163 0 0 1 1.563 0l2.47 2.274a.667.667 0 0 1-.903.98l-2.348-2.16-2.349 2.16a.667.667 0 0 1-.903-.98zM6 10.667A.667.667 0 1 1 6 12H2a.667.667 0 0 1 0-1.333zm0-3.334a.667.667 0 0 1 0 1.334H2a.667.667 0 0 1 0-1.334zm7.815-5.156a.666.666 0 1 1 .903.98l-2.47 2.274a1.163 1.163 0 0 1-1.563 0l-2.47-2.274a.667.667 0 0 1 .903-.98l2.349 2.16zM6 4a.667.667 0 0 1 0 1.333H2A.667.667 0 1 1 2 4z"
      />
    </svg>
  );
}
